// const baseUrl1 = "https://jellyfish-app-4v5ou.ondigitalocean.app";
// const baseUrl = "https://jellyfish-app-4v5ou.ondigitalocean.app";
// const baseLocal = "https://jellyfish-app-4v5ou.ondigitalocean.app";

const baseUrl1 = "https://obelabs.onrender.com";
const baseUrl = "https://obelabs.onrender.com";
const baseLocal = "https://obelabs.onrender.com";

export { baseUrl, baseLocal };
